import * as graphql from "lib/types/generated/graphql-types"
import { CustomReasonCode } from "lib/types/generated/graphql-types"
import FailedCompensation from "./FailedCompensation"
import { Container } from "../../../../views/Orders/ManageOrder/ManageOrder.styled"
import { OrderSummary } from "./OrderSummary/OrderSummary"
import { Cart } from "./Cart/Cart"
import React, { useState } from "react"
import CompensationAction from "./Cart/CompensationAction"
import StatusPopup from "./Cart/StatusPopup"
import { Compensation } from "../../../../classes/order/Compensation"
import PendingCompensation from "./PendingCompensation"

type Props = {
  order: graphql.Order
  refetch: () => void
  loading: boolean
  failedCompensations: graphql.OrderCompensation[]
  orderHistory: graphql.OrderHistory
  customReasons: CustomReasonCode[]
}

const CompensationOrder = ({
  order,
  refetch,
  loading,
  failedCompensations,
  orderHistory,
  customReasons
}: Props) => {
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [showStatusPopup, setShowStatusPopup] = useState(false)
  const [startedCompensation, setStartedCompensation] = useState("")
  const compensations = new Compensation(order.Compensations)
  const filteredCompensations = order?.Compensations?.filter(
    (compensation) => !compensation.completed && !compensation.started
  )
  const [giftCardAction, setGiftCardAction] = useState<graphql.InputActionGiftCard>({
    actionType: graphql.InputActionType.Auto
  })
  const [bonusAction, setBonusAction] = useState<graphql.InputActionBonus>({
    actionType: graphql.InputActionType.Auto
  })
  const [paymentAction, setPaymentAction] = useState<graphql.InputActionPaymentCompensation>({
    actionType: graphql.InputActionType.Auto
  })

  if (compensations.pending() && !showStatusPopup)
    return (
      <PendingCompensation
        pendingCompensation={compensations.getPendingCompensation()}
        orderRefetch={refetch}
        orderLoading={loading}
      />
    )

  return (
    <>
      {showStatusPopup && startedCompensation && (
        <StatusPopup
          setShowStatusPopup={setShowStatusPopup}
          compensationId={startedCompensation}
          refetchOrder={refetch}
        />
      )}
      {failedCompensations?.length > 0 ? (
        failedCompensations.map((compensation: graphql.OrderCompensation) => (
          <FailedCompensation
            key={compensation.id}
            failedCompensation={compensation}
            setShowStatusPopup={setShowStatusPopup}
            setStartedCompensation={setStartedCompensation}
            orderHistory={orderHistory.history}
          />
        ))
      ) : !showConfirmation ? (
        <Container>
          <div>
            <OrderSummary
              order={order}
              refetch={refetch}
              orderLoading={loading}
              customReasons={customReasons}
            />
          </div>
          <div>
            <Cart
              order={order}
              refetch={refetch}
              setShowConfirmation={setShowConfirmation}
              orderLoading={loading}
            />
          </div>
        </Container>
      ) : (
        <Container>
          <div>
            <Cart
              order={order}
              refetch={refetch}
              setShowConfirmation={setShowConfirmation}
              summaryMode={true}
              orderLoading={loading}
            />
          </div>
          <div>
            {filteredCompensations?.map((compensation) => (
              <CompensationAction
                key={compensation.id}
                compensation={compensation}
                actionState={{
                  giftCardAction,
                  setGiftCardAction,
                  bonusAction,
                  setBonusAction,
                  paymentAction,
                  setPaymentAction
                }}
                orderId={order.id}
                setShowStatusPopup={setShowStatusPopup}
                setStartedCompensation={setStartedCompensation}
                setShowConfirmation={setShowConfirmation}
              />
            ))}
          </div>
        </Container>
      )}
    </>
  )
}

export default CompensationOrder
